import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IAccountAppealFormProps } from "../../model/interface";
import { Image, Input, Label } from "@fluentui/react-components";
import { ACCOUNT_APPEAL_EXAMPLE_IMAGE, USER_ID_MAX_LENGTH } from "../../constants/constants";
import Required from "../required/required";
import './AccountAppealForm.scss';
import { isValidBase64Image } from "../../utils/appealUtil";

export default function AccountAppealForm(props: IAccountAppealFormProps) {
    const [userId, setUserId] = useState<string>("");
    const [hasEditedUserId, setHasEditedUserId] = useState<boolean>(false);
    const [imageCanLoad, setImageCanLoad] = useState<boolean>(false);
    const userIdInputRef = useRef<HTMLInputElement>(null);
    const { t } = useTranslation();
    const displayedUserId = hasEditedUserId ? userId : props.currentFormInfo.userId;

    const handleSuspendedUserIdChange = (suspendedUserId: string) => {
        const newSuspendedUserId = suspendedUserId;
        setHasEditedUserId(true);
        setUserId(newSuspendedUserId);
        props.userIdChange(newSuspendedUserId);

    }
    const handleImageLoadingError = () => {
        setImageCanLoad(false);
    }

    useEffect(() => {
        if (!imageCanLoad) {
            setImageCanLoad(isValidBase64Image(ACCOUNT_APPEAL_EXAMPLE_IMAGE));
        }
    }
    ,[]); //eslint-disable-line

    useEffect(() => {
        if (document.activeElement !== userIdInputRef.current) {
            userIdInputRef.current?.focus();
        }
    }, []);

    return (
        <div>
            <div className="form-overview">
                <h1 className="form-overview__header"> {t('Appeal.Common.submit-an-appeal')}</h1>
                <p className="form-overview__paragraph">{t('Appeal.Account.appeal-overview')}</p>
            </div>
            <div className="form-fields">
                <div className="userId">
                    <Label id="userIdLabel">
                        {t('Appeal.Account.suspended-user-id')}
                        <span><Required /></span>
                    </Label>
                    <Input
                        ref={userIdInputRef}
                        id="appealerUserId"
                        className="userIdInput"
                        aria-labelledby="userIdLabel"
                        aria-describedby={props.currentFormInfo.hasSubmissionError ?
                            "submissionErrorMessage" :
                            (!props.currentFormInfo.couldFindSuspendedUserId ? "noAccountFoundMessage" : undefined)}
                        data-testid="appealerUserId"
                        type="text"
                        required
                        onChange={(e: any, data: { value: string; }) => handleSuspendedUserIdChange(data.value)}
                        placeholder={displayedUserId ? undefined : t('Appeal.Account.suspended-user-id-placeholder')}
                        value={displayedUserId}
                        maxLength={USER_ID_MAX_LENGTH}
                    />
                    {props.currentFormInfo.hasSubmissionError &&
                        <span
                            id="submissionErrorMessage"
                            className="subtext__error"
                            role="alert">{t('Common.problem-submitting-request')}</span>
                    }
                    {(!props.currentFormInfo.hasSubmissionError && !props.currentFormInfo.couldFindSuspendedUserId) &&
                        <span
                            id="noAccountFoundMessage"
                            className="subtext__error"
                            role="alert">{t('Appeal.Account.no-suspended-account-found')}</span>
                    }
                    <span className="subtext">{imageCanLoad
                        ? t('Appeal.Account.suspended-user-id-subtext')
                        : t('Appeal.Account.suspended-user-id-subtext-alternate')}
                    </span>
                    {imageCanLoad &&
                        <div className="locked-account">
                            <h5 className="locked-account__header" aria-hidden="true">{t('Appeal.Account.locked-account-header')}</h5>
                            <Image className="locked-account__image" alt={t('Appeal.Account.locked-account-alt-text')} fit="contain" shape="rounded" onError={handleImageLoadingError} src={ACCOUNT_APPEAL_EXAMPLE_IMAGE} />
                        </div>
                    }

                </div>
            </div>
        </div>
    );
};